module.exports = __webpack_public_path__ + "static/media/stablishmentnewicon.f892e507.svg";